<template>
  <layout>
    <div class="page-view">
      <el-row class="carousel">
        <el-col :xs="24" :sm="24" :md="24">
          <van-swipe :autoplay="2000" indicator-color="#F39800">
            <van-swipe-item
              class="carousel-item"
              :key="c.id"
              v-for="c in homeIndex.carousel_chart"
            >
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                lazy-load
                :src="c.imgUrl"
              />
            </van-swipe-item>
          </van-swipe>
        </el-col>
      </el-row>
      <!-- 核心业务 -->
      <div class="core">
        <el-row class="core-row" :gutter="10">
          <el-col
            v-for="(c, index) in homeIndex.core_area"
            :key="c.id"
            @click.native="goNucleus(c, index)"
            class="core-plate"
            :xs="24"
            :sm="8"
            :md="8"
          >
            <div class="core-plate__tit">{{ c.title }}</div>
            <div class="core-plate__cont">
              <div class="core-plate__cont-left">
                <van-image width="100%" lazy-load :src="c.imgUrl" />
              </div>
              <ul class="core-plate__cont-right">
                <li v-for="(txt, i) in c.inputArr" :key="i">
                  {{ txt }}
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="serve">
        <div v-for="(h, i) in homeIndex.home_module" :key="h.id">
          <div class="serve__textCont">
            <p class="serve__textCont-titCont">{{ h.name }}</p>
            <p class="serve__textCont-nameplate">{{ h.nameEn }}</p>
            <p class="serve__textCont-describe">{{ h.content }}</p>
          </div>
          <!-- 企业服务 -->
          <div class="serve__plate serve__plateA" v-if="i === 0">
            <div class="swipeBox">
              <van-swipe indicator-color="#ffffff">
                <van-swipe-item @dragstart.prevent v-for="(p, ic) in h.list" :key="p.id">
                  <div
                    class="serve__plateA-bg"
                    :style="`background-image: linear-gradient( 180deg, rgba(102,102,102,0) 0%, rgba(0,0,0,0.6) 100%), url(${p.imgUrl});`"
                  >
                    <div class="serve__plateA-bg-cont">
                      <p class="subtitle">{{ p.contentTitle }}</p>
                      <!-- <p
                        class="title"
                        v-html="p.content?.replace(/\n/g, '<br>')"></p> -->
                      <p
                        class="title"
                        @click="goEnterprise(ic, 0)"
                        v-html="p.content.split('\n')[0]"
                      ></p>
                      <p
                        class="title"
                        @click="goEnterprise(ic, 1)"
                        v-html="p.content.split('\n')[1]"
                      ></p>
                      <p
                        class="title"
                        @click="goEnterprise(ic, 2)"
                        v-html="p.content.split('\n')[2]"
                      ></p>
                      <p
                        class="title"
                        @click="goEnterprise(ic, 3)"
                        v-html="p.content.split('\n')[3]"
                      ></p>
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
          </div>
          <!-- 政府服务 -->
          <ul v-else-if="i === 1" class="serve__plate serve__plateB">
            <li
              class="serve__plateB-item"
              :style="`background-image: url(${p.imgUrl});`"
              @click="goGave(i, p.routingPath)"
              v-for="(p, i) in h.list"
              :key="p.id"
            ></li>
          </ul>
          <!-- 定制服务 -->
          <ul v-else-if="i === 2" class="serve__plate serve__plateC">
            <li
              class="serve__plateC-item"
              :style="`background-image: linear-gradient( 180deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.2) 100%), url(${p.imgUrl});`"
              v-for="(p, i) in h.list"
              @click="goCustom(p, i)"
              :key="p.id"
            >
              <div class="serve__plateC-item__cont">
                <p class="title">{{ p.title }}</p>
                <p class="describe">{{ p.contentTitle }}</p>
              </div>
            </li>
          </ul>
          <!-- 新闻中心 -->
          <template v-else>
            <div class="serve__plate serve__plateD phone-hidden">
              <ul class="serve__plateD-image">
                <li
                  class="serve__plateD-image-item"
                  :style="`background-image: linear-gradient( 180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%), url(${p.imgUrl});`"
                  v-for="p in h.list.slice(0, 2)"
                  @click="toDetails(p)"
                  :key="p.id"
                >
                  <div class="serve__plateD-image-item-cont">
                    <p class="title">{{ p.title }}</p>
                    <p class="describe">{{ p.contentTitle }}</p>
                  </div>
                </li>
              </ul>
              <ul class="serve__plateD-text">
                <li
                  class="serve__plateD-text-item"
                  v-for="p in h.list.slice(0, 2)"
                  @click="toDetails(p)"
                  :key="p.id"
                >
                  <p class="title">{{ p.title }}</p>
                  <p class="describe">{{ p.contentTitle }}</p>
                </li>
              </ul>
              <div @click="goMoreInquiy" class="serve__plateD-btn">
                更多资讯
              </div>
            </div>
            <div class="serve__plate serve__plateD ipad-hidden">
              <ul class="serve__plateD-image">
                <li
                  class="serve__plateD-image-item"
                  :style="`background-image: linear-gradient( 180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%), url(${p.imgUrl});`"
                  v-for="p in h.list"
                  @click="toDetails(p)"
                  :key="p.id"
                >
                  <div class="serve__plateD-image-item-cont">
                    <p class="title">{{ p.title }}</p>
                    <p class="describe">{{ p.contentTitle }}</p>
                  </div>
                </li>
              </ul>
              <div @click="goMoreInquiy" class="serve__plateD-btn">
                更多资讯
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/moblie/Layout.vue'
import bg5 from '@/assets/images/5.png'
import { homeIndex } from '@/api/index'
import '@vant/touch-emulator'
export default {
  components: { Layout },
  data() {
    return {
      homeIndex: {}
    }
  },
  created() {
    this.getHomeIndex()
  },
  methods: {
    goNucleus(info, index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: 'static/products',
            params: { info: info }
          })
          break
        case 1:
          this.$router.push({
            name: 'static/abilities',
            params: { info: info }
          })
          break
        case 2:
          this.$router.push({
            name: 'static/solutions',
            params: { info: info }
          })
          break
        default:
          return
      }
      this.$store.commit('changeTabCheck', {
        idNum: '',
        sumName: 'detailTempIndex/templateDetail'
      })
      this.$store.state.enterp_somFlg = ''
    },
    getHomeIndex() {
      homeIndex().then((res) => {
        var { data } = res
        this.homeIndex = data.data
        this.homeIndex.home_module[0].list = [
          {
            createBy: null,
            createTime: '2023-11-23 18:08:58',
            updateBy: null,
            updateTime: '2024-08-16 13:46:27',
            remark: null,
            id: 1,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业安全通讯与系统',
            titleEn: 'commitment',
            contentTitle: '企业安全通讯与系统',
            content: '企业集群安全通讯\n终端双域操作系统\n企业私有通讯系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/785235c6-bd07-4c38-9c58-576118fb4db8.png',
            sortOrder: 1,
            status: true,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2023-11-23 18:09:45',
            updateBy: null,
            updateTime: '2024-08-16 13:46:48',
            remark: null,
            id: 2,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业移动办公自动化',
            titleEn: 'innovate',
            contentTitle: '企业移动办公自动化',
            content: '移动安全办公系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/d6e30e7d-68a3-4cd3-8cfb-b20e1a9c914a.png',
            sortOrder: 2,
            status: false,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2024-01-10 14:53:19',
            updateBy: null,
            updateTime: '2024-08-16 13:47:13',
            remark: null,
            id: 3,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业信息化管理',
            titleEn: null,
            contentTitle: '企业信息化管理',
            content: '企业数据管理EMM\n物联网管理系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/0a4586b4-cb4d-4548-a04d-1e8091b31008.png',
            sortOrder: 3,
            status: false,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2024-01-10 14:53:44',
            updateBy: null,
            updateTime: '2024-08-16 13:47:38',
            remark: null,
            id: 4,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业安全定制',
            titleEn: null,
            contentTitle: '企业安全定制与采购服务',
            content: '移动终端定制\n智能设备定制\n安全系统定制\n安全软件定制',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/62b7838c-1946-4c2e-a7a7-eb40a9d46541.png',
            sortOrder: 4,
            status: false,
            routingPath: null
          },
          {
            id: 5,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业采购方案',
            titleEn: null,
            contentTitle: '企业采购方案',
            content: '月付模式\n一次性买断\n分期付款\n研发后置',
            imgUrl: bg5,
            sortOrder: 5,
            status: false,
            routingPath: null
          }
        ]
      })
    },
    goGave(row, name) {
      let sum = parseInt(row) + 1
      let num = '3-' + sum
      // console.log("测试点击", num);
      this.$router.push({
        name: name,
        params: {}
      })
      this.$store.commit('changeTabCheck', {
        idNum: num,
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    },
    goEnterprise(row, num) {
      console.log(row, num)
      if (row == 0 && num == 0) {
        this.$router.push({
          name: "/static/detail/enterpriseClusterSecurityCommunication",
          params: {},
        });
      } else if (row == 0 && num == 1) {
        this.$router.push({
          name: "/static/detail/dualDomainSystem",
          params: {},
        });
      } else if (row == 0 && num == 2) {
        this.$router.push({
          name: "/static/detail/enterprisePrivateCommunicationSystem",
          params: {},
        });
      } else if (row == 1 && num == 0) {
        this.$router.push({
          name: "/static/detail/safeOffice",
          params: {},
        });
      } else if (row == 1 && num == 1) {
        this.$router.push({
          name: "enterpriseHome/enterpriseSmartOffice",
          params: {},
        });
      } else if (row == 2 && num == 0) {
        this.$router.push({
          name: "/static/detail/EMM",
          params: {},
        });
      } else if (row == 2 && num == 1) {
        this.$router.push({
          name: "/static/detail/iotSystem",
          params: {},
        });
      } else if (row == 3 && num == 0) {
        this.$router.push({
          name: "/static/detail/mobileTerminalCustom",
          params: {},
        });
      } else if (row == 3 && num == 1) {
        this.$router.push({
          name: "/static/detail/intelligentDeviceCustom",
          params: {},
        });
      } else if (row == 3 && num == 2) {
        this.$router.push({
          name: "/static/detail/safeSystemCustom",
          params: {},
        });
      } else if (row == 3 && num == 3) {
        this.$router.push({
          name: "/static/detail/safeSoftwareCustom",
          params: {},
        });
      } else if (row == 4 && num == 0) {
        this.$router.push({
          name: "/static/detail/payByMonth",
          params: {},
        });
      } else if (row == 4 && num == 1) {
        this.$router.push({
          name: "/static/detail/payOneTime",
          params: {},
        });
      } else if (row == 4 && num == 2) {
        this.$router.push({
          name: "/static/detail/paySplit",
          params: {},
        });
      } else if (row == 4 && num == 3) {
        this.$router.push({
          name: "/static/detail/payBefore",
          params: {},
        });
      }
      this.$store.commit('changeTabCheck', {
        idNum: '',
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    },
    goCustom(row, num) {
      let name = row.title == '私人定制' ? 6 : 59
      this.$router.push({
        name: row.routingPath,
        params: { flgId: num + 1, id: name }
        // params: { id: num },
      })
      this.$store.commit('changeTabCheck', {
        idNum: '',
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    },
    goMoreInquiy() {
      this.$router.push({
        name: 'myHome/companyConsulting',
        params: {}
      })
      this.$store.commit('changeTabCheck', {
        idNum: '',
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    },
    toDetails(row) {
      this.$router.push({
        name: 'myHome/companyConsulting/newsDetails',
        // params: { info: row.content },
        params: { id: row.id }
      })
      this.$store.commit('changeTabCheck', {
        idNum: '',
        sumName: ''
      })
      this.$store.state.enterp_somFlg = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 343px;
  .page-view {
    .carousel {
      width: 100%;
      &-item {
        width: 100%;
        height: 230px;
      }
    }
    .core {
      width: 316px;
      margin: auto;
      &-plate {
        &__tit {
          font-size: 18px;
          line-height: 21px;
          text-align: center;
          padding-top: 30px;
          padding-bottom: 18px;
        }
        &__cont {
          padding: 30px 28px;
          display: flex;
          &-left {
            width: 85px;
            margin-right: 60px;
          }
          &-right {
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            list-style-type: disc;
            li {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .serve {
      padding: 30px 0;
      width: $container-width;
      margin: auto;
      &__textCont {
        &-titCont {
          font-weight: 600;
          font-size: 20px;
          line-height: 23px;
          padding-bottom: 4px;
          display: inline-block;
          border-bottom: 1px solid #888888;
          margin-bottom: 2px;
        }
        &-nameplate {
          font-weight: 300;
          font-size: 9px;
          line-height: 13px;
          margin-bottom: 18px;
        }
        &-describe {
          font-weight: 300;
          font-size: 9px;
          line-height: 11px;
          margin-bottom: 20px;
        }
      }
      &__plate {
        margin-bottom: 30px;
      }
      &__plateA {
        &-bg {
          width: $container-width;
          height: 200px;
          &-cont {
            left: 14px;
            bottom: 35px;
            .subtitle {
              font-weight: 500;
              font-size: 10px;
              color: rgba($color: #ffffff, $alpha: 0.6);
              line-height: 12px;
              margin-bottom: 5px;
            }
            .title {
              font-weight: bold;
              font-size: 12px;
              color: #ffffff;
              line-height: 18px;
            }
          }
        }
      }
      &__plateB {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 336px;
        margin: 0 auto 16px;
        &-item {
          width: 160px;
          height: 140px;
          background-position-y: -20px;
          margin-bottom: 14px;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      &__plateC {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 336px;
        margin: 0 auto 16px;
        &-item {
          width: 160px;
          height: 120px;
          margin-bottom: 14px;
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
          &__cont {
            position: absolute;
            left: 10px;
            bottom: 10px;
            .title {
              font-weight: 500;
              font-size: 12px;
              color: #ffffff;
              line-height: 14px;
            }
            .describe {
              font-weight: 300;
              font-size: 10px;
              color: #ffffff;
              opacity: 0.6;
              line-height: 10px;
              width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &__plateD {
        width: 336px;
        margin: 0 auto 0;
        display: flex;
        flex-direction: column;
        align-content: center;
        &-image {
          margin-bottom: 20px;
          &-item {
            width: 100%;
            height: 200px;
            margin-bottom: 14px;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            &-cont {
              position: absolute;
              left: 14px;
              bottom: 16px;
              .title {
                font-weight: 500;
                font-size: 12px;
                color: #ffffff;
                line-height: 14px;
                width: 280px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 5px;
              }
              .describe {
                font-weight: 300;
                font-size: 10px;
                color: #ffffff;
                line-height: 10px;
                opacity: 0.8;
                width: 310px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        &-text {
          background: #fbfbfb;
          padding: 10px 16px;
          margin-bottom: 20px;

          &-item {
            padding: 20px 0;
            border-bottom: 1px solid #f1f1f1;
            &:nth-last-of-type(1) {
              border-bottom: none;
            }
            .title {
              font-weight: 500;
              font-size: 12px;
              color: #333333;
              line-height: 14px;
              margin-bottom: 6px;
            }
            .describe {
              font-weight: 300;
              font-size: 10px;
              color: #666666;
              line-height: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        &-btn {
          padding: 6px 18px;
          font-weight: 500;
          font-size: 11px;
          color: #04758e;
          line-height: 13px;
          display: inline-block;
          border: 1px solid #04758e;
          color: #04758e;
          margin: auto;
          text-align: center;
          &:active {
            transform: scale(0.98);
            background: rgba($color: #000000, $alpha: 0.2);
          }
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    .carousel {
      width: 100%;
      &-item {
        width: 100%;
        height: 416px;
      }
    }
    .core {
      width: $container-width;
      margin: 40px auto 30px;
      &-row {
        display: flex;
      }
      &-plate {
        display: flex;
        flex-direction: column;
        &__tit {
          font-size: 18px;
          line-height: 21px;
          text-align: center;
          padding-bottom: 8px;
          font-weight: 700;
        }
        &__cont {
          flex-grow: 1;
          box-shadow: 0px 0 10px 0px rgba(5, 32, 55, 0.2);
          padding: 15px;
          display: flex;
          align-items: center;
          &-left {
            width: 83px;
            margin-right: 17px;
          }
          &-right {
            font-weight: 400;
            font-size: 8px;
            color: #151a23;
            list-style-type: disc;
            li {
              margin-bottom: 10px;
              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
    .serve {
      padding: 30px 0;
      width: $container-width;
      margin: auto;
      &__textCont {
        text-align: center;
        &-titCont {
          font-weight: 600;
          font-size: 20px;
          padding-bottom: 4px;
          display: inline-block;
          border-bottom: 1px solid #888888;
          margin-bottom: 2px;
        }
        &-nameplate {
          font-weight: 300;
          font-size: 12px;
          margin-bottom: 14px;
        }
        &-describe {
          font-weight: 300;
          font-size: 12px;
          margin-bottom: 20px;
        }
      }
      &__plate {
        margin-bottom: 30px;
      }
      &__plateA {
        .swipeBox {
          width: 589px;
          margin: auto;
        }
        &-bg {
          width: $container-width;
          height: 343px;
          &-cont {
            left: 24px;
            bottom: 35px;
            .subtitle {
              font-weight: 500;
              font-size: 12px;
              color: rgba($color: #ffffff, $alpha: 0.6);
              margin-bottom: 10px;
            }
            .title {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
              line-height: 25px;
            }
          }
        }
      }
      &__plateB {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        margin: 0 auto 16px;
        &-item {
          width: 225px;
          height: 200px;
          background-position-y: -20px;
          margin-bottom: 14px;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
      &__plateC {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        margin: 0 auto 16px;
        &-item {
          width: 49%;
          height: 200px;
          margin-bottom: 14px;
          background-repeat: no-repeat;
          background-size: cover;
          position: relative;
          &__cont {
            position: absolute;
            left: 10px;
            bottom: 10px;
            .title {
              font-weight: 500;
              font-size: 15px;
              color: #ffffff;
            }
            .describe {
              font-weight: 300;
              font-size: 13px;
              color: #ffffff;
              opacity: 0.6;
              width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &__plateD {
        width: $container-width;
        margin: 0 auto 0;
        display: flex;
        flex-direction: column;
        align-content: center;
        &-image {
          margin-bottom: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          &-item {
            &:nth-of-type(1) {
              width: 100%;
              height: 300px;
            }
            width: 32%;
            height: 140px;
            margin-bottom: 14px;
            background-repeat: no-repeat;
            background-size: cover;
            position: relative;
            &-cont {
              position: absolute;
              left: 14px;
              bottom: 16px;
              width: 100%;
              .title {
                font-weight: 500;
                font-size: 14px;
                color: #ffffff;
                width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 5px;
              }
              .describe {
                font-weight: 300;
                font-size: 12px;
                color: #ffffff;
                opacity: 0.8;
                width: 80%;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
        &-btn {
          padding: 6px 18px;
          font-weight: 500;
          font-size: 11px;
          color: #04758e;
          line-height: 13px;
          display: inline-block;
          border: 1px solid #04758e;
          color: #04758e;
          margin: auto;
          text-align: center;
          &:active {
            transform: scale(0.98);
            background: rgba($color: #000000, $alpha: 0.2);
          }
        }
      }
    }
  }
}
.page-view {
  .carousel {
    &-item {
    }
  }
  .core {
    &-plate {
      &__tit {
        font-weight: bold;
        color: #151a23;
        line-height: 21px;
      }
      &__cont {
        background: #ffffff;
        box-shadow: 0px 0px 15px 0px rgba(5, 32, 55, 0.2);
        &-left {
        }
        &-right {
          font-family: Source Han Sans CN, Source Han Sans CN;
          color: #151a23;
        }
      }
    }
  }
  .serve {
    &__textCont {
      text-align: center;
      &-titCont {
        color: #151a23;
      }
      &-nameplate {
        color: #666666;
      }
      &-describe {
        color: #666666;
      }
    }
    &__plate {
    }
    &__plateA {
      &-bg {
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        &-cont {
          position: absolute;
          .txtCont {
          }
          .subtitle {
          }
          .title {
          }
        }
      }
    }
  }
}
</style>
